<bit-side-nav [variant]="variant">
  <ng-content></ng-content>
  <!-- SLG Comment : Hide footer side info of Bitwarden -->
  <!-- <ng-container slot="footer">
    <navigation-product-switcher></navigation-product-switcher>
    <app-toggle-width></app-toggle-width>
  </ng-container> -->
</bit-side-nav>
